var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["carousel-slider/carousel-product-image-container.j2"] = require( "carousel-slider/carousel-product-image-container.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/family/family-product-image-viewer.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/family/family-product-image-viewer.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("imageUrl")) {
var t_4 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_4);
if(t_1.hasOwnProperty("videoUrl")) {
var t_5 = t_1.videoUrl;
} else {
cb(new Error("cannot import 'videoUrl'")); return;
}
context.setVariable("videoUrl", t_5);
output += "\n\n<div class=\"o-carousel__outer dom-family-product-image-viewer\" data-qa-family-carousel-module>\n\n    ";
output += "\n    ";
var t_6;
t_6 = (lineno = 5, colno = 32, runtime.callWrap(t_4, "imageUrl", context, []));
frame.set("baseImageUrl", t_6, true);
if(frame.topLevel) {
context.setVariable("baseImageUrl", t_6);
}
if(frame.topLevel) {
context.addExport("baseImageUrl", t_6);
}
output += "\n    ";
var t_7;
t_7 = (lineno = 6, colno = 32, runtime.callWrap(t_5, "videoUrl", context, []));
frame.set("baseVideoUrl", t_7, true);
if(frame.topLevel) {
context.setVariable("baseVideoUrl", t_7);
}
if(frame.topLevel) {
context.addExport("baseVideoUrl", t_7);
}
output += "\n    ";
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productImageViewer")),"imageStyle");
frame.set("imageStyle", t_8, true);
if(frame.topLevel) {
context.setVariable("imageStyle", t_8);
}
if(frame.topLevel) {
context.addExport("imageStyle", t_8);
}
output += "\n    ";
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productImageViewer")),"colorCode");
frame.set("colorCode", t_9, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_9);
}
if(frame.topLevel) {
context.addExport("colorCode", t_9);
}
output += "\n    ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"familyProductImagePreset");
frame.set("imageHeight", t_10, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_10);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_10);
}
output += "\n    ";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"video_height");
frame.set("videoHeight", t_11, true);
if(frame.topLevel) {
context.setVariable("videoHeight", t_11);
}
if(frame.topLevel) {
context.addExport("videoHeight", t_11);
}
output += "\n    ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"familyProductImagePreset");
frame.set("preset", t_12, true);
if(frame.topLevel) {
context.setVariable("preset", t_12);
}
if(frame.topLevel) {
context.addExport("preset", t_12);
}
output += "\n    ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"displayName");
frame.set("altText", t_13, true);
if(frame.topLevel) {
context.setVariable("altText", t_13);
}
if(frame.topLevel) {
context.addExport("altText", t_13);
}
output += "\n    ";
var t_14;
t_14 = true;
frame.set("showControls", t_14, true);
if(frame.topLevel) {
context.setVariable("showControls", t_14);
}
if(frame.topLevel) {
context.addExport("showControls", t_14);
}
output += "\n\n    ";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceHashToIndex")),"code")),runtime.contextOrFrameLookup(context, frame, "colorCode"));
frame.set("currentPrimarySliceIndex", t_15, true);
if(frame.topLevel) {
context.setVariable("currentPrimarySliceIndex", t_15);
}
if(frame.topLevel) {
context.addExport("currentPrimarySliceIndex", t_15);
}
output += "\n    ";
var t_16;
t_16 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "primarySlice")),"sliceItems")),runtime.contextOrFrameLookup(context, frame, "currentPrimarySliceIndex"));
frame.set("currentPrimarySlice", t_16, true);
if(frame.topLevel) {
context.setVariable("currentPrimarySlice", t_16);
}
if(frame.topLevel) {
context.addExport("currentPrimarySlice", t_16);
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "currentPrimarySlice")) {
output += "\n        ";
var t_17;
t_17 = env.getFilter("length").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "currentPrimarySlice")),"carouselCodes"),[]));
frame.set("carouselCodeCount", t_17, true);
if(frame.topLevel) {
context.setVariable("carouselCodeCount", t_17);
}
if(frame.topLevel) {
context.addExport("carouselCodeCount", t_17);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_18;
t_18 = 0;
frame.set("carouselCodeCount", t_18, true);
if(frame.topLevel) {
context.setVariable("carouselCodeCount", t_18);
}
if(frame.topLevel) {
context.addExport("carouselCodeCount", t_18);
}
output += "\n    ";
;
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_small") || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_small")) {
output += "\n        ";
var t_19;
t_19 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"family_product")),"small_image_height");
frame.set("imageHeight", t_19, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_19);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_19);
}
output += "\n    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_medium")) {
output += " \n        ";
var t_20;
t_20 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"family_product")),"medium_image_height");
frame.set("imageHeight", t_20, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_20);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_20);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_21;
t_21 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"carousel")),"family_product")),"large_image_height");
frame.set("imageHeight", t_21, true);
if(frame.topLevel) {
context.setVariable("imageHeight", t_21);
}
if(frame.topLevel) {
context.addExport("imageHeight", t_21);
}
output += "\n    ";
;
}
;
}
output += "\n\n    <div class=\"";
if(runtime.contextOrFrameLookup(context, frame, "carouselCodeCount") < 2) {
output += "c-family-product__carousel--single";
;
}
output += "\">\n\n        ";
env.getTemplate("carousel-slider/carousel-product-image-container.j2", false, "product/templates/family/family-product-image-viewer.j2", null, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
t_22.render(context.getVariables(), frame, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
output += t_23
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/family/family-product-image-viewer.j2"] , dependencies)